// extracted by mini-css-extract-plugin
export var container = "_s5-0";
export var inputWidth = "_s5-1";